var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: { visible: _vm.showModal, size: "50%" },
          on: {
            "update:visible": function($event) {
              _vm.showModal = $event
            }
          }
        },
        [
          _c("template", { slot: "title" }, [
            _c(
              "div",
              {
                staticClass: "d-flex items-center justify-content-between mr-3"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "d-flex align-items-center",
                    style: { gap: "8px" }
                  },
                  [
                    _c(
                      "el-tag",
                      {
                        staticClass: "rounded-circle",
                        attrs: { type: "warning", effect: "dark" }
                      },
                      [_c("i", { staticClass: "el-icon-date" })]
                    ),
                    _vm._v(" "),
                    _c("h5", { staticClass: "font-weight-semibold mb-0" }, [
                      _vm._v("Evento / ")
                    ]),
                    _vm._v(" "),
                    _c("h6", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(_vm.mutatorDate))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.event && _vm.event.status
                  ? _c("el-tag", { attrs: { type: _vm.getTagTypeByStatus } }, [
                      _vm._v(_vm._s(_vm.event.status))
                    ])
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "px-3 pb-3" },
            [
              _c(
                "el-tabs",
                {
                  attrs: { type: "border-card" },
                  model: {
                    value: _vm.activeName,
                    callback: function($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName"
                  }
                },
                [
                  _c("el-tab-pane", { attrs: { name: "first" } }, [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _c("i", { staticClass: "el-icon-tickets" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-1" }, [_vm._v("Detalhes")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "d-flex flex-column",
                        style: { gap: "12px" }
                      },
                      [
                        !_vm.canBeEdited &&
                        _vm.event &&
                        _vm.event.status != "REPROVADO"
                          ? _c(
                              "el-form",
                              {
                                ref: "eventEditForm",
                                attrs: {
                                  model: _vm.payload,
                                  "label-position": "top",
                                  "status-icon": "",
                                  rules: _vm.rules
                                }
                              },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 12 } },
                                  [
                                    _c(
                                      "el-col",
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "titulo" } },
                                          [
                                            _c("label", [_vm._v("Titulo")]),
                                            _vm._v(" "),
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "Titulo do evento",
                                                disabled:
                                                  !_vm.shouldBeEdit ||
                                                  _vm.closedApprovedEventEdit
                                              },
                                              model: {
                                                value: _vm.payload.titulo,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.payload,
                                                    "titulo",
                                                    $$v
                                                  )
                                                },
                                                expression: "payload.titulo"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "email" } },
                                          [
                                            _c("label", [_vm._v("Despesas")]),
                                            _vm._v(" "),
                                            _c(
                                              "el-checkbox-group",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  disabled:
                                                    !_vm.shouldBeEdit ||
                                                    _vm.closedApprovedEventEdit
                                                },
                                                model: {
                                                  value: _vm.payload.despesas,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.payload,
                                                      "despesas",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "payload.despesas"
                                                }
                                              },
                                              _vm._l(_vm.expenses, function(
                                                expense
                                              ) {
                                                return _c(
                                                  "el-checkbox-button",
                                                  {
                                                    key: expense.value,
                                                    attrs: {
                                                      label: expense.value,
                                                      disabled:
                                                        expense.value ===
                                                        "ALMOCO"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(expense.text) +
                                                        "\n                                            "
                                                    )
                                                  ]
                                                )
                                              }),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.handleItemsExpenses
                                      ? _c("el-col", { staticClass: "mb-3" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "bg-light border rounded-lg p-2 d-flex align-items-center justify-content-between",
                                              style: { gap: "12px" }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-items-center",
                                                  style: { gap: "8px" }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-files"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "h6",
                                                    {
                                                      staticClass:
                                                        "mb-0 font-weight-bold"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Itens da despezas"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.shouldBeEdit &&
                                              !_vm.closedApprovedEventEdit
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      attrs: { size: "small" },
                                                      nativeOn: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.addItemForExpense()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-plus"
                                                      }),
                                                      _vm._v(
                                                        "\n                                            Novo item\n                                        "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.payload.itens_despesa.length > 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "p-3 rounded mt-2",
                                                  style: {
                                                    border:
                                                      "1px dashed #dedede",
                                                    borderSpacing: "4px"
                                                  }
                                                },
                                                [
                                                  _vm._l(
                                                    _vm.payload.itens_despesa,
                                                    function(
                                                      item_despesa,
                                                      index
                                                    ) {
                                                      return [
                                                        !item_despesa.deleted
                                                          ? _c(
                                                              "div",
                                                              {
                                                                key:
                                                                  item_despesa.id,
                                                                staticClass:
                                                                  "d-flex align-items-end",
                                                                style: {
                                                                  gap: "12px",
                                                                  paddingInline:
                                                                    "20px",
                                                                  marginBottom:
                                                                    "12px"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticClass:
                                                                      "mb-0",
                                                                    attrs: {
                                                                      prop:
                                                                        "itens_despesa." +
                                                                        index +
                                                                        ".tipo",
                                                                      rules: [
                                                                        {
                                                                          required: true,
                                                                          message:
                                                                            "O tipo da despesa é obrigátorio",
                                                                          trigger:
                                                                            "change"
                                                                        }
                                                                      ]
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "label",
                                                                      [
                                                                        _vm._v(
                                                                          "Tipo"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "el-radio-group",
                                                                      {
                                                                        attrs: {
                                                                          size:
                                                                            "small",
                                                                          disabled:
                                                                            !_vm.shouldBeEdit ||
                                                                            _vm.closedApprovedEventEdit
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .payload
                                                                              .itens_despesa[
                                                                              index
                                                                            ]
                                                                              .tipo,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm
                                                                                .payload
                                                                                .itens_despesa[
                                                                                index
                                                                              ],
                                                                              "tipo",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "payload.itens_despesa[index].tipo"
                                                                        }
                                                                      },
                                                                      _vm._l(
                                                                        [
                                                                          {
                                                                            value:
                                                                              "PEDAGIO",
                                                                            text:
                                                                              "Pedágio"
                                                                          },
                                                                          {
                                                                            value:
                                                                              "ESTACIONAMENTO",
                                                                            text:
                                                                              "Estacionamento"
                                                                          },
                                                                          {
                                                                            value:
                                                                              "UBER",
                                                                            text:
                                                                              "Uber"
                                                                          }
                                                                        ],
                                                                        function(
                                                                          item_des_tipo
                                                                        ) {
                                                                          return _c(
                                                                            "el-radio-button",
                                                                            {
                                                                              key:
                                                                                item_des_tipo.value,
                                                                              attrs: {
                                                                                label:
                                                                                  item_des_tipo.value
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                                            " +
                                                                                  _vm._s(
                                                                                    item_des_tipo.text
                                                                                  ) +
                                                                                  "\n                                                        "
                                                                              )
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticClass:
                                                                      "mb-0",
                                                                    attrs: {
                                                                      prop:
                                                                        "itens_despesa." +
                                                                        index +
                                                                        ".valor",
                                                                      rules: [
                                                                        {
                                                                          required: true,
                                                                          message:
                                                                            "O valor da despesa é obrigátorio",
                                                                          trigger:
                                                                            "blur"
                                                                        }
                                                                      ]
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "label",
                                                                      [
                                                                        _vm._v(
                                                                          "Valor"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "el-input",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "mask",
                                                                            rawName:
                                                                              "v-mask",
                                                                            value: [
                                                                              "#,##",
                                                                              "##,##",
                                                                              "###,##"
                                                                            ],
                                                                            expression:
                                                                              "['#,##', '##,##', '###,##']"
                                                                          }
                                                                        ],
                                                                        attrs: {
                                                                          size:
                                                                            "small",
                                                                          placeholder:
                                                                            "0,00",
                                                                          maxlength:
                                                                            "250",
                                                                          "suffix-icon":
                                                                            "el-icon-money",
                                                                          maxlength: 6,
                                                                          disabled:
                                                                            !_vm.shouldBeEdit ||
                                                                            _vm.closedApprovedEventEdit
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .payload
                                                                              .itens_despesa[
                                                                              index
                                                                            ]
                                                                              .valor,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm
                                                                                .payload
                                                                                .itens_despesa[
                                                                                index
                                                                              ],
                                                                              "valor",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "payload.itens_despesa[index].valor"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "template",
                                                                          {
                                                                            slot:
                                                                              "prepend"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "R$"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      2
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _vm.shouldBeEdit &&
                                                                !_vm.closedApprovedEventEdit
                                                                  ? _c(
                                                                      "el-button",
                                                                      {
                                                                        attrs: {
                                                                          size:
                                                                            "small",
                                                                          plain:
                                                                            "",
                                                                          type:
                                                                            "danger",
                                                                          circle:
                                                                            ""
                                                                        },
                                                                        nativeOn: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            $event.preventDefault()
                                                                            return _vm.handleRemoveItemExpense(
                                                                              item_despesa.id
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "el-icon-delete"
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            : _vm._e()
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      {
                                        attrs: {
                                          span: _vm.isAuthorized ? 12 : 24
                                        }
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "obs" } },
                                          [
                                            _c("label", [
                                              _vm._v("Observações")
                                            ]),
                                            _vm._v(" "),
                                            _c("el-input", {
                                              attrs: {
                                                type: "textarea",
                                                placeholder:
                                                  "Observações sobre o evento",
                                                maxlength: "250",
                                                "show-word-limit": "",
                                                rows: 5,
                                                disabled:
                                                  !_vm.shouldBeEdit ||
                                                  _vm.closedApprovedEventEdit
                                              },
                                              model: {
                                                value: _vm.payload.obs,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.payload,
                                                    "obs",
                                                    $$v
                                                  )
                                                },
                                                expression: "payload.obs"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.isAuthorized
                                      ? _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  prop: "obs_coordenacao"
                                                }
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    "Observações Coordenação"
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("el-input", {
                                                  attrs: {
                                                    type: "textarea",
                                                    placeholder:
                                                      "Observações da coordenação sobre o evento",
                                                    maxlength: "250",
                                                    "show-word-limit": "",
                                                    rows: 5
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.payload
                                                        .obs_coordenacao,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.payload,
                                                        "obs_coordenacao",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "payload.obs_coordenacao"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.closedApprovedEventEdit &&
                                    this.payload.editar_evento
                                      ? _c(
                                          "el-col",
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  prop: "motivo_edicao",
                                                  rules: [
                                                    {
                                                      required: true,
                                                      message:
                                                        "O motivo para edição é obrigátorio",
                                                      trigger: "blur"
                                                    },
                                                    {
                                                      validator: _vm.validateMin(
                                                        10
                                                      ),
                                                      trigger: "change"
                                                    }
                                                  ]
                                                }
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    "Justificativa para edição"
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("el-input", {
                                                  attrs: {
                                                    type: "textarea",
                                                    placeholder:
                                                      "Motivo para a edição do evento",
                                                    maxlength: "250",
                                                    "show-word-limit": "",
                                                    rows: 5,
                                                    disabled: _vm.isLoading
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.payload.motivo_edicao,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.payload,
                                                        "motivo_edicao",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "payload.motivo_edicao"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.shouldBeEdit &&
                                    _vm.event &&
                                    (_vm.event.status == "APROVADO" ||
                                      _vm.event.status == "REPROVADO")
                                      ? _c("el-col", [
                                          _vm.closedApprovedEventEdit
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "alert alert-success",
                                                  attrs: { role: "alert" }
                                                },
                                                [
                                                  _c("div", [
                                                    _c(
                                                      "p",
                                                      { staticClass: "mb-0" },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            "Evento aprovado. Caso deseje edita-lo, clique no botão (editar) logo abaixo."
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.event.analisado_por
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-items-center mb-3",
                                                  style: { gap: "12px" }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      style: {
                                                        fontSize: "12px"
                                                      }
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "Analisado por: "
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.event.analisado_por
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex align-items-center",
                                                          style: { gap: "8px" }
                                                        },
                                                        [
                                                          _c(
                                                            "el-avatar",
                                                            {
                                                              attrs: {
                                                                size: "small"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.event.analisado_por.name.charAt(
                                                                    0
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex align-items-center"
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  style: {
                                                                    fontSize:
                                                                      "12px"
                                                                  }
                                                                },
                                                                [
                                                                  _c("b", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .event
                                                                          .analisado_por
                                                                          .name
                                                                      )
                                                                    )
                                                                  ]),
                                                                  _vm._v(
                                                                    "\n                                                    em " +
                                                                      _vm._s(
                                                                        _vm.formatDate(
                                                                          _vm
                                                                            .event
                                                                            .updated_at
                                                                        )
                                                                      ) +
                                                                      "\n                                                "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            : _vm._e()
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("el-col", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center justify-space-between"
                                        },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _vm.validateApprove
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "info",
                                                        plain: "",
                                                        size: "small"
                                                      },
                                                      nativeOn: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.handleDisapproveEvent()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-close"
                                                      }),
                                                      _vm._v(
                                                        "\n                                                Reprovar\n                                            "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.validateApprove
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "success",
                                                        plain: "",
                                                        size: "small"
                                                      },
                                                      nativeOn: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.handleApproveEvent()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-check"
                                                      }),
                                                      _vm._v(
                                                        "\n                                                Aprovar\n                                            "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.event &&
                                              _vm.event.status == "APROVADO" &&
                                              _vm.isAuthorized
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "warning",
                                                        plain: "",
                                                        size: "small"
                                                      },
                                                      nativeOn: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.handleRevokeApprovedEvent()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-refresh-left"
                                                      }),
                                                      _vm._v(
                                                        "\n                                                Revogar aprovação\n                                            "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.shouldBeEdit &&
                                              _vm.event &&
                                              _vm.event.status == "APROVADO" &&
                                              !_vm.dateIsBeforeToday &&
                                              !this.payload.editar_evento
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "warning",
                                                        plain: "",
                                                        size: "small"
                                                      },
                                                      nativeOn: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.handleEditEvent()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-edit-outline"
                                                      }),
                                                      _vm._v(
                                                        "\n                                                Editar\n                                            "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              this.payload.editar_evento
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "info",
                                                        plain: "",
                                                        size: "small"
                                                      },
                                                      nativeOn: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.handleEditEvent()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                Cancelar edição\n                                            "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center justify-content-end flex-grow-1"
                                            },
                                            [
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        plain: "",
                                                        disabled: _vm.isLoading
                                                      },
                                                      on: {
                                                        click: function() {
                                                          _vm.toggleModal()
                                                          _vm.resetForm()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    Cancelar\n                                                "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "danger",
                                                        plain: "",
                                                        disabled: _vm.isLoading
                                                      },
                                                      nativeOn: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.handleDestroyEvent()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.isLoading
                                                        ? _c("i", {
                                                            staticClass:
                                                              "el-icon-loading"
                                                          })
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-delete"
                                                      }),
                                                      _vm._v(
                                                        "\n                                                    Excluir\n                                                "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  this.payload.editar_evento
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "primary",
                                                            plain: "",
                                                            disabled:
                                                              _vm.isLoading
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.handleEditSubmit
                                                          }
                                                        },
                                                        [
                                                          _vm.isLoading
                                                            ? _c("i", {
                                                                staticClass:
                                                                  "el-icon-loading"
                                                              })
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c("i", {
                                                            staticClass:
                                                              "fas fa-check-circle"
                                                          }),
                                                          _vm._v(
                                                            "\n                                                    Salvar\n                                                "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  !this.payload.editar_evento &&
                                                  _vm.event &&
                                                  _vm.event.status != "APROVADO"
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "primary",
                                                            plain: "",
                                                            disabled:
                                                              _vm.isLoading
                                                          },
                                                          on: {
                                                            click: _vm.onSubmit
                                                          }
                                                        },
                                                        [
                                                          _vm.isLoading
                                                            ? _c("i", {
                                                                staticClass:
                                                                  "el-icon-loading"
                                                              })
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c("i", {
                                                            staticClass:
                                                              "fas fa-check-circle"
                                                          }),
                                                          _vm._v(
                                                            "\n                                                    Salvar\n                                                "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _c(
                              "div",
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c("el-col", { attrs: { span: 12 } }, [
                                      _vm.event
                                        ? _c(
                                            "h6",
                                            {
                                              staticClass:
                                                "mb-0 font-weight-bold"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(_vm.event.titulo) +
                                                  "\n                                    "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _c("el-col", { attrs: { span: 12 } }, [
                                      _vm.event &&
                                      _vm.event.cumpriu == null &&
                                      _vm.event.status != "REPROVADO"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-end"
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "danger",
                                                    plain: "",
                                                    size: "small"
                                                  },
                                                  nativeOn: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.handleDenyEvent()
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-close"
                                                  }),
                                                  _vm._v(
                                                    "\n                                            Não cumpriu\n                                        "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "success",
                                                    plain: "",
                                                    size: "small"
                                                  },
                                                  nativeOn: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.handleConfirmEvent()
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-check"
                                                  }),
                                                  _vm._v(
                                                    "\n                                            Cumpriu\n                                        "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.event && _vm.event.cumpriu
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "rounded border p-3 mt-3"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center justify-content-between"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-items-center",
                                                style: { gap: "8px" }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-check"
                                                }),
                                                _vm._v(
                                                  "\n                                        Realizado?\n                                    "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.event
                                              ? _c(
                                                  "el-tag",
                                                  {
                                                    attrs: {
                                                      type:
                                                        _vm.event.cumpriu ==
                                                        "SIM"
                                                          ? "success"
                                                          : "danger",
                                                      size: "small"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.event.cumpriu)
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.event.justificativa
                                          ? _c("p", { staticClass: "mt-3" }, [
                                              _c("strong", [_vm._v("Motivo:")]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.event.justificativa
                                                  )
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("el-divider"),
                                _vm._v(" "),
                                _vm.event && _vm.event.status == "REPROVADO"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "alert alert-secondary",
                                        attrs: { role: "alert" }
                                      },
                                      [
                                        _c("div", [
                                          _c("p", { staticClass: "mb-0" }, [
                                            _c("b", [
                                              _vm._v(
                                                "Este evento foi reprovado."
                                              )
                                            ])
                                          ])
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex flex-column",
                                    style: { gap: "12px" }
                                  },
                                  [
                                    _c(
                                      "el-descriptions",
                                      {
                                        attrs: {
                                          title: "Despesas",
                                          column: 4,
                                          size: "small",
                                          border: true
                                        }
                                      },
                                      _vm._l(_vm.expenses, function(expense) {
                                        return _c(
                                          "el-descriptions-item",
                                          {
                                            key: expense.value,
                                            attrs: {
                                              span: 4,
                                              label: expense.text
                                            }
                                          },
                                          [
                                            _vm.event &&
                                            _vm.event.tipos_despesas.includes(
                                              expense.value
                                            )
                                              ? _c(
                                                  "el-tag",
                                                  {
                                                    staticClass: "rounded-pill",
                                                    attrs: {
                                                      type: "success",
                                                      size: "small"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            Sim\n                                        "
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "el-tag",
                                                  {
                                                    staticClass: "rounded-pill",
                                                    attrs: {
                                                      type: "danger",
                                                      size: "small"
                                                    }
                                                  },
                                                  [_vm._v("Não")]
                                                )
                                          ],
                                          1
                                        )
                                      }),
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.event && _vm.event.despesas.length > 0
                                      ? _c(
                                          "div",
                                          { style: { gap: "12px" } },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-items-center mb-3",
                                                style: { gap: "8px" }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-files"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "h6",
                                                  {
                                                    staticClass:
                                                      "mb-0 font-weight-bold"
                                                  },
                                                  [_vm._v("Itens da despezas")]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-table",
                                              {
                                                staticClass: "rounded",
                                                attrs: {
                                                  data: _vm.event.despesas,
                                                  align: "center",
                                                  border: "",
                                                  "row-key": "id",
                                                  size: "mini"
                                                }
                                              },
                                              [
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "Tipo",
                                                    prop: "tipo",
                                                    align: "left"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(scope) {
                                                          return _c("div", {}, [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row.tipo
                                                              )
                                                            )
                                                          ])
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    false,
                                                    652465215
                                                  )
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "Valor",
                                                    prop: "valor",
                                                    align: "left"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(scope) {
                                                          return _c("div", {}, [
                                                            _vm._v(
                                                              "R$ " +
                                                                _vm._s(
                                                                  scope.row
                                                                    .valor
                                                                )
                                                            )
                                                          ])
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    false,
                                                    2719964934
                                                  )
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "el-row",
                                      { attrs: { gutter: 20 } },
                                      [
                                        _c("el-col", { attrs: { span: 12 } }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "rounded border p-3"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-items-center mb-3",
                                                  style: { gap: "8px" }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-warning-outline"
                                                  }),
                                                  _vm._v(
                                                    "\n                                            Observações\n                                        "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.event && _vm.event.obs
                                                ? _c("p", [
                                                    _vm._v(
                                                      _vm._s(_vm.event.obs)
                                                    )
                                                  ])
                                                : _c("el-empty", {
                                                    attrs: {
                                                      description:
                                                        "Nenhuma observação"
                                                    }
                                                  })
                                            ],
                                            1
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("el-col", { attrs: { span: 12 } }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "rounded border p-3"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-items-center mb-3",
                                                  style: { gap: "8px" }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-warning-outline"
                                                  }),
                                                  _vm._v(
                                                    "\n                                            Observações da coordenação\n                                        "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.event &&
                                              _vm.event.obs_coordenacao
                                                ? _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.event
                                                          .obs_coordenacao
                                                      )
                                                    )
                                                  ])
                                                : _c("el-empty", {
                                                    attrs: {
                                                      description:
                                                        "Nenhuma observação"
                                                    }
                                                  })
                                            ],
                                            1
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.event && _vm.event.analisado_por
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center mt-3",
                                        style: { gap: "12px" }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { style: { fontSize: "12px" } },
                                          [_c("b", [_vm._v("Analisado por: ")])]
                                        ),
                                        _vm._v(" "),
                                        _vm.event.analisado_por
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-items-center",
                                                style: { gap: "8px" }
                                              },
                                              [
                                                _c(
                                                  "el-avatar",
                                                  { attrs: { size: "small" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.event.analisado_por.name.charAt(
                                                          0
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-items-center"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        style: {
                                                          fontSize: "12px"
                                                        }
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.event
                                                                .analisado_por
                                                                .name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          "\n                                            em " +
                                                            _vm._s(
                                                              _vm.formatDate(
                                                                _vm.event
                                                                  .updated_at
                                                              )
                                                            ) +
                                                            "\n                                        "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-tab-pane",
                    { attrs: { name: "second" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("i", { staticClass: "el-icon-timer" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "ml-1" }, [
                          _vm._v("Histórico")
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.event && _vm.event.historico.length > 0
                        ? _c(
                            "el-timeline",
                            _vm._l(_vm.event.historico, function(
                              historic,
                              index
                            ) {
                              return _c(
                                "el-timeline-item",
                                {
                                  key: historic.id,
                                  attrs: {
                                    timestamp: _vm.formatDate(
                                      historic.created_at,
                                      true
                                    ),
                                    placement: "top",
                                    color: "#0bbd87"
                                  }
                                },
                                [
                                  _c("el-card", [
                                    _c("h6", [
                                      _c("b", [_vm._v(_vm._s(historic.status))])
                                    ]),
                                    _vm._v(" "),
                                    historic.obs
                                      ? _c("h6", [_vm._v(_vm._s(historic.obs))])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    historic.user
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center",
                                            style: { gap: "8px" }
                                          },
                                          [
                                            _c(
                                              "el-avatar",
                                              { attrs: { size: "small" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    historic.user.name.charAt(0)
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex flex-column"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "font-weight-bold",
                                                    style: {
                                                      fontSize: "14px",
                                                      marginBottom: "-4px"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(historic.user.name)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-muted",
                                                    style: { fontSize: "14px" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        historic.user.email
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ])
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c("EventDenyReason", {
        ref: "eventDenyReason",
        on: { dispatch: _vm.handleDispatch }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11301ab2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11301ab2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/agenda/EventShowModal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-11301ab2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/agenda/EventShowModal.vue
// module chunks = 2